import _ from "lodash";
import * as folderTypes from "../constants/constants-folder";

export default {
  data() {
    return {
      ...folderTypes,
      foldersLoading: false,
      folders: [],
      selectedFolder: null,
      activeFolder: null,
      copiedFolder: null,
      rootFolder: null,
    };
  },
  mounted() {
    window.addEventListener(
      "setFolderLoadingStart",
      this.setFolderLoadingStart
    );
    window.addEventListener("setFolderLoadingStop", this.setFolderLoadingStop);
  },
  beforeDestroy() {
    window.removeEventListener(
      "setFolderLoadingStart",
      this.setFolderLoadingStart
    );
    window.removeEventListener(
      "setFolderLoadingStop",
      this.setFolderLoadingStop
    );
  },
  methods: {
    isPublishedFolder(folder) {
      if (!folder) return false;

      if (folder.folderType === "EDUCATIONALPUBLIC") {
        return true;
      }

      const publishedFolderNames = ["Published", "My Published"];
      return publishedFolderNames.some(
        (name) =>
          folder.name && folder.name.toLowerCase().includes(name.toLowerCase())
      );
    },

    findUnpublishedFolder(folders) {
      if (!folders || !Array.isArray(folders)) return null;

      for (const folder of folders) {
        if (
          folder.folderType === "EDUCATIONAL" ||
          folder.folderType === "EDUCATIONALOTHER"
        ) {
          return folder;
        }

        const unpublishedFolderNames = ["Unpublished", "Creation Folder"];
        const folderName = (folder.name || "").toLowerCase();
        if (
          unpublishedFolderNames.some((name) =>
            folderName.includes(name.toLowerCase())
          )
        ) {
          return folder;
        }

        if (folder.children && folder.children.length > 0) {
          const childResult = this.findUnpublishedFolder(folder.children);
          if (childResult) return childResult;
        }
      }

      return null;
    },
    findResponseChildFolder(systemIdNumber, formattedDate) {
      if (!this.folders || !Array.isArray(this.folders)) return null;

      // Function to recursively search folders
      const searchFolders = (folders, parent = null) => {
        for (const folder of folders) {
          // First, find the "Responses from Recipients" parent folder
          if (folder.folderType === "RESPONSEFROMRECIPIENTS") {
            // Check if it has children
            if (folder.children && folder.children.length > 0) {
              // Create the expected folder name pattern: "TH-ASN-0025_Jan 7_2026"
              const expectedFolderName = `${systemIdNumber}_${formattedDate}`;
              // Search for matching child folder
              const matchingChild = folder.children.find((child) => {
                return child.name === expectedFolderName;
              });

              if (matchingChild) {

                // Set the parent folder to opened state
                if (parent) {
                  parent.opened = true;
                  folder.opened = true; // Also open the RESPONSEFROMRECIPIENTS folder
                }

                // Update the folders array to reflect the opened state
                this.folders = [...this.folders];

                return matchingChild;
              }
            }
          }

          // Recursively search in children
          if (folder.children && folder.children.length > 0) {
            const result = searchFolders(folder.children, folder);
            if (result) return result;
          }
        }
        return null;
      };

      return searchFolders(this.folders);
    },
    getAllEducationalFolders(options, onNodeSelected) {
      const responseCallBack = (response) => {
        this.buildEducationalFolders(response, onNodeSelected);
        this.foldersLoading = false;
      };
      const errorCallBack = (folders) => {
        this.buildEducationalFolders({
          folders,
        });
        this.foldersLoading = false;
      };
      this.foldersLoading = true;
      this.folders = null;
      this.fetchEducationalFolders(options).then(
        responseCallBack,
        errorCallBack
      );
    },
    fetchEducationalFolders(_params) {
      const { userId } = _params;

      return new Promise((resolve, reject) => {
        this.$api.getAllEducationalMaterialFolderByUserId(userId).then(
          (response) => {
            if (!this.$handleResponse(response)) {
              console.warn("API response handling failed");
              resolve({
                folders: [],
              });
            } else {
              const data = _.cloneDeep(response.data.payload);

              let folders = [];

              // Add publicBox folder if it exists
              if (data.publicBox && data.publicBox.length > 0) {
                data.publicBox.forEach((folder) => {
                  const processedFolder = {
                    ...folder,
                    root: true,
                    opened: false,
                    dropDisabled: true,
                    dragDisabled: true,
                    children: folder.children || [],
                  };
                  folders.push(processedFolder);
                });
              }

              // Add user folders
              if (data.userFolder && data.userFolder.length > 0) {
                data.userFolder.forEach((folder) => {
                  const processedFolder = {
                    ...folder,
                    root: true,
                    opened: false,
                    dropDisabled: true,
                    dragDisabled: true,
                    children: folder.children || [],
                  };
                  folders.push(processedFolder);
                });
              }
              resolve({
                folders,
                activeFolder: folders[0],
              });
            }
          },
          (error) => {
            console.error("API error:", error);
            this.$handleError(error);
            reject([]);
          }
        );
      });
    },
    buildEducationalFolders({ activeFolder, folders }, onNodeSelected) {
      // console.log("Building folders with:", { activeFolder, folders });

      const processedFolders = _.cloneDeep(folders).map((folder) => ({
        ...folder,
        text: folder.name,
        children: folder.children || [],
        opened: folder.opened || false,
      }));

      this.folders = processedFolders;
      this.rootFolder = _.cloneDeep(this.folders[0]);

      let active =
        this.folders.find(
          (folder) =>
            (folder.folderType === "EDUCATIONALOTHER" || folder.folderType === "EDUCATIONAL") &&
            folder.name === "Private"
        ) || this.folders[0];
      if (activeFolder && activeFolder.length) {
        active = activeFolder[0];
        active.children = _.filter(activeFolder, (item, index) => index);
      }

      this.activeFolder = active;
      this.selectedFolder = _.cloneDeep(active);
      // Trigger callback if provided
      if (onNodeSelected && typeof onNodeSelected === "function") {
        onNodeSelected(active);
      } else {
        // Emit the default selection if no callback is passed.
        this.$emit("selected", active);
      }
    },
    resetEducationalFolders() {
      this.copiedFolder = null;
      this.selectedFolder = _.cloneDeep(this.rootFolder);
    },
    cutEducationalAction(item) {
      this.selectedFolder = item;
      this.copiedFolder = this.selectedFolder;
    },
    setFolderLoadingStart(data) {
      this.foldersLoading = data.detail.foldersLoading;
    },
    setFolderLoadingStop(data) {
      this.foldersLoading = data.detail.foldersLoading;
    },
  },
};
